module.exports = __webpack_public_path__ + "assets/media/w3_1.9181f0d7.mp4";